import { render, staticRenderFns } from "./InstagramEmbed.vue?vue&type=template&id=7f208608&scoped=true"
import script from "./InstagramEmbed.vue?vue&type=script&lang=js"
export * from "./InstagramEmbed.vue?vue&type=script&lang=js"
import style0 from "./InstagramEmbed.vue?vue&type=style&index=0&id=7f208608&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f208608",
  null
  
)

export default component.exports